import { Tooltip } from "zhihao-ui-react";
import { CloseSlideIcon } from "./CloseSlideIcon";
import { OpenSlideIcon } from "./OpenSlideIcon";

export interface SlideToggleProps {
    hidden: boolean;
    onChange: (hidden: boolean) => void;
}

/** 标签栏侧边导航显隐切换按钮。 */
export function SlideToggle({ hidden, onChange }: SlideToggleProps) {
    return (
        <span className="tabs-control">
            <Tooltip title={hidden ? "展开侧边导航" : "收起侧边导航"} placement="bottom" effect="dark">
                <button
                    type="button"
                    className="slide-toggle-button"
                    aria-label={hidden ? "展开侧边导航" : "收起侧边导航"}
                    aria-pressed={hidden}
                    onClick={() => onChange(!hidden)}
                >
                    {hidden ? <OpenSlideIcon /> : <CloseSlideIcon />}
                </button>
            </Tooltip>
        </span>
    );
}

export default SlideToggle;
